<div class="employee-basket-progress-bar">
  <div
    class="employee-basket-progress-bar__fill"
    [style.background-color]="color()"
    [style.width.%]="fillPercentage()"
  ></div>
</div>
